export default __webpack_public_path__ + "static/rec-2000-i-3cb756dbedb341e23156661adaf591d0.png";